import React, { Component } from "react";
import _ from "underscore";
import moment from "moment";
import fetch from "isomorphic-fetch";
import { Layout, Button, Alert, Col, Row } from "antd";
const { Header, Footer, Sider, Content } = Layout;
import { TimeSeries, TimeRange, Index } from "pondjs";
import {
  ChartContainer,
  ChartRow,
  Charts,
  YAxis,
  LineChart,
  Resizable,
  Legend,
  styler
} from "react-timeseries-charts";

const firebase = require("firebase/app");
require("firebase/storage");

const MAX_SENSORS = 7;
const DEFAULT_SENSORS = ["RPM", "TPS", "MAP", "A/F", "Gear"];
const DEFAULT_COLORS = {
  "RPM": "ff0000",
  "TPS": "00ff00",
  "MAP": "0000ff"
};

var config = {
  apiKey: "AIzaSyA4pZcLPTu-6UBqePikK9N0mz_UjEOSI-k",
  storageBucket: "firebase-tunelogs.appspot.com"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const stringToColor = function (str, alpha) {
  var colour = "#";
  if (DEFAULT_COLORS[str] !== undefined) {
    colour +=  DEFAULT_COLORS[str];
  } else {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xff;
      colour += ("00" + value.toString(16)).substr(-2);
    }
  }
  const rgb = rgbToHex(colour);
  return `rgba(${rgb.r},${rgb.g},${rgb.b}, ${alpha})`;
};

const rgbToHex = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
  } : null;
}

const darkAxis = {
  label: {
    stroke: "none",
    fill: "#AAA", // Default label color
    fontWeight: 200,
    fontSize: 14,
    font: '"Goudy Bookletter 1911", sans-serif"'
  },
  values: {
    stroke: "none",
    fill: "#888",
    fontWeight: 100,
    fontSize: 11,
    font: '"Goudy Bookletter 1911", sans-serif"'
  },
  ticks: {
    fill: "none",
    stroke: "#AAA",
    opacity: 0.2
  },
  axis: {
    fill: "none",
    stroke: "#AAA",
    opacity: 1
  }
};

function indexDate(date) {
  return date;
}

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.handleRescale = _.debounce(this.rescale, 300);
    this.state = {
      max: 500,
      timerange: new TimeRange([indexDate(new Date()), indexDate(new Date())]),
      sensors: [],
      series: {},
      active: {},
      urls: {},
      error: null,
      tracker: null
    };
  }

  async loadSerieData(serie, url) {
    const { series } = this.state;
    if (Object.keys(series).indexOf(serie) > 0) {
      return;
    }

    await fetch(url, {
      method: "GET"
    })
      .then(async res => {
        if (res.status === 200) {
          return res.json();
        }
        throw new Error(
          `Unexpected response code ${res.status} loading serie data`
        );
      })
      .then(response => {
        const { series } = this.state;
        series[serie] = new TimeSeries({
          name: serie,
          columns: ["time", serie],
          points: response.data.map(entry => [
            indexDate(new Date(parseInt(entry.ts, 10))),
            parseFloat(entry.value, 10)
          ])
        });
        this.setState({ series });
      })
      .catch(ex => {
        console.error(ex);
        this.setState({ sensors: [], error: { type: 'fatal', error: ex } });
      });
  }

  async componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search);
    const anchor = window.location.hash.replace("#", "");
    const path = window.location.pathname.replace("/", "");
    var datalogId = "";
    if (urlParams.has("d")) {
      datalogId = urlParams.get("d");
    } else if (anchor !== "") {
      datalogId = anchor;
    } else if (path !== "") {
      datalogId = path;
    } else {
      console.log("Invalid recorded log link provided!");
      this.setState({ error: { type: 'fatal', error: "Invalid recorded log link provided!" } });
      return;
    }

    // Create a storage reference from our storage service
    var storageRef = firebase.storage().ref();
    var datalogRef = storageRef
      .child("datalogs")
      .child(datalogId)
      .child("datalog.json");

    datalogRef
      .getDownloadURL()
      .then(url => {
        fetch(url, {
          method: "GET"
        })
          .then(async res => {
            if (res.status === 200) {
              return res.json();
            }
            throw new Error(`Invalid recorded log link provided ${datalogId} ! ${res.status}`);
          })
          .then(response => {
            // Initial timerange
            const range = new TimeRange([
              parseInt(response.start, 10),
              parseInt(response.end, 10)
            ]);
            const active = {};

            for (const sensor of Object.keys(response.sensors)) {
              active[sensor] = DEFAULT_SENSORS.indexOf(sensor) >= 0;
            }

            // Series details loading
            const urls = {};
            for (const serie of Object.keys(response.sensors)) {
              let fileName = response.sensors[serie];
              let sensorRef = datalogRef.parent.child(fileName);
              sensorRef.getDownloadURL().then(url => {
                if (active[serie]) {
                  this.loadSerieData(serie, url);
                }
                urls[serie] = url;
              });
            }

            this.setState({
              sensors: response.sensors,
              timerange: range,
              error: null,
              active,
              series: {},
              urls
            });
            this.handleRescale(range);
          })
          .catch(ex => {
            console.error(ex);
            this.setState({ sensors: [], error: { type: 'fatal', error: ex } });
          });
      })
      .catch(function (error) {
        // Handle any errors
        console.log("Invalid path provided: " + error);
        this.setState({ error: { type: 'fatal', error } });
        return;
      });
  }

  rescale(timerange, active = this.state.active) {
    const { series } = this.state;
    let max = 50;
    for (const entry of Object.keys(series)) {
      const maxSeries = series[entry].crop(timerange).max(entry);
      if (maxSeries > max && active[entry]) {
        max = maxSeries;
      }
    }
    this.setState({ max });
  }

  handleTimeRangeChange = timerange => {
    this.setState({ timerange });
    this.handleRescale(timerange);
  };

  handleActiveChange = key => {
    const { active, series, urls } = this.state;

    // If item is enabled, then the user is disabling it, so no check needed
    if (!active[key]) {
      let totalActive = 0;
      for (const entry of Object.keys(active)) {
        if (active[entry]) {
          totalActive += 1;
        }
      }

      if (totalActive >= MAX_SENSORS) {
        this.setState({
          error: {
            type: 'non-fatal', error:
              "Max number of sensors displaying. Please remove other sensor before continuing."
          }
        });
        return;
      }
    }

    // If it's ok to continue, check if serie is already loaded, just render
    if (Object.keys(series).indexOf(key) < 0) {
      this.loadSerieData(key, urls[key]);
    }

    active[key] = !active[key];
    this.setState({ active, error: null });
    this.handleRescale(this.state.timerange, active);
  };

  renderChart = style => {
    const { series, timerange, active, max } = this.state;

    if (Object.keys(series).length <= 0) {
      return <Alert message="No sensor data loaded..." type="warning" />;
    }

    let charts = [];
    let axis = [];
    let trackerLabels = [];

    // Plot the graph for each serie selected by the user
    for (const key of Object.keys(series)) {
      if (!active[key]) {
        continue;
      }

      if (this.state.tracker) {
        const i = series[key].bisect(new Date(this.state.tracker));
        const vv = series[key].at(i).get(key);
        trackerLabels.push({ label: key, value: vv });
      }

      const axisKey = `axis-${key}`;
      charts.push(
        <LineChart
          key={key}
          axis={axisKey}
          series={series[key]}
          columns={[key]}
          style={style}
          interpolation="curveBasis"
        />
      );

      axis.push(
        <YAxis
          id={axisKey}
          key={axisKey}
          label={key}
          min={0}
          max={series[key].crop(timerange).max(key)}
          width={70}
          type="linear"
        />
      );
    }

    return (
      <ChartContainer
        title="Data log"
        style={{
          background: "#201d1e",
          borderRadius: 8,
          borderStyle: "solid",
          borderWidth: 1,
          borderColor: "#232122"
        }}
        timeAxisStyle={darkAxis}
        titleStyle={{
          color: "#EEE",
          fontWeight: "bold"
        }}
        padding={20}
        paddingTop={5}
        paddingBottom={0}
        enableDragZoom
        onTimeRangeChanged={this.handleTimeRangeChange}
        timeRange={timerange}
        trackerPosition={this.state.tracker}
        onTrackerChanged={this.handleTrackerChanged}
      >
        <ChartRow
          height="500"
          trackerInfoValues={trackerLabels}
          trackerInfoHeight={10 + trackerLabels.length * 16}
          trackerInfoWidth={140}
        >
          {axis}
          <Charts>{charts}</Charts>
        </ChartRow>
      </ChartContainer>
    );
  };

  handleTrackerChanged = t => {
    this.setState({ tracker: t });
  };

  render() {
    const { sensors, active } = this.state;
    const legend = [];
    const styles = [];

    let sensorsFromMap = Object.keys(sensors);
    sensorsFromMap.sort();
    for (const sensor of sensorsFromMap) {
      legend.push({
        key: sensor,
        label: sensor,
        disabled: !active[sensor]
      });

      styles.push({
        key: sensor,
        color: stringToColor(sensor, 0.4),
        selected: stringToColor(sensor, 1),
        width: 1
      });
    }



    const style = styler(styles);

    let error = "";
    let content = "";
    if (this.state.error && this.state.error.type === 'fatal') {
      error = <Alert message={this.state.error.error} type="error" />;
    } else if (legend.length > 0) {
      content =
          <Row>
            <Col xs={2} className="legends-container" >
              <h2>Sensor List</h2>
              <Legend
                type="swatch"
                stack
                style={style}
                categories={legend}
                onSelectionChange={this.handleActiveChange}
              />
            </Col>
            <Col xs={22}>
              {this.state.error && <Alert key={0} message={this.state.error.error} type="error" style={{marginTop: '16px'}} />} 
              <Resizable>{this.renderChart(style)}</Resizable>
            </Col>
          </Row>
    }

    return (
      <div>
        <Layout className="graph-container">
          <Layout>
            <Header>
              <div>
                <a href="https://tunelogs.com">
                  <img src="/static/img/logo.png" alt="Tune Logs" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.tunelogs">
                  <img src="/static/img/google_play.png" alt="Download TUNELOGS at Google Play" align="right" />
                </a>
              </div>
            </Header>
            <Content>
              {error}
              {content}
            </Content>
          </Layout>
        </Layout>
        <style global jsx>{`
          body {
            background-color: rgb(32, 29, 30);
            color: "white";
            padding: 30px;

            .graph-container {
              .ant-layout-header {
                background-color: rgb(32, 29, 30);
              }

              .ant-layout-header {
                padding: 0 0 30px 0;
                margin: 0;
              }

              .ant-layout-content {
                background-color: rgb(32, 29, 30);
              }

              .legends-container {
                h2 {
                  color: white;
                  font-size: 16px;
                  font-weight: bold;
                  margin-top: 10px;
                }
                div {
                  color: white !important;
                }
              }
            }
          }
        `}</style>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./pages/index.js